<template>
    <main class="smaller-padding data-table">
        <div class="tab-selector">
            <TabSelector
                v-model="showActive"
                :data-tabs="tabs"
                @input="reloadTable"
            ></TabSelector>
        </div>
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            :hide-actions="true"
            :must-sort="true"
            :no-data-text="$t('message.generics.message.noData')"
            :no-results-text="$t('message.generics.message.noData')"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <ApisTableItem
                    :api="props.item"
                    @revoked="reloadTable"
                ></ApisTableItem>
            </template>
        </v-data-table>
    </main>
</template>

<script>
import TabSelector from "@components/TabSelector";
import ApisTableItem from "@views/apis/components/ApisTableItem";
import EventBus from "@packages/event-bus";
import provider from "@mixins/provider";

export default {
    components: {
        ApisTableItem,
        TabSelector,
    },

    data() {
        return {
            filter: "",
            list: [],
            loading: false,
            page: 0,
            showActive: true,
        };
    },

    computed: {
        headers() {
            return this.filter
                ? [
                      {
                          text: this.$t("message.generics.message.name"),
                          value: "name",
                      },
                      {
                          text: this.$t(
                              "message.generics.message.creationDate"
                          ),
                          value: "creationDate",
                      },
                      {
                          text: this.$t("message.admGenerics.message.edition"),
                          sortable: false,
                      },
                  ]
                : [
                      {
                          text: this.$t("message.generics.message.name"),
                          value: "name",
                      },
                      {
                          text: this.$t("message.api.message.revocationDate"),
                          value: "revocationDate",
                      },
                      {
                          text: this.$t("message.api.message.clientId"),
                          value: "clientId",
                      },
                  ];
        },
        tabs() {
            return [
                {
                    label: this.$t("message.api.message.active"),
                    value: true,
                },
                {
                    label: this.$t("message.api.message.revoked"),
                    value: false,
                },
            ];
        },
    },

    mixins: [provider],

    methods: {
        reloadTable() {
            this.page = 0;

            this.loadItems();
        },
        async loadItems() {
            try {
                this.loading = true;

                const list = await this.$api.apis.search({
                    page: this.page,
                    filter: this.filter,
                    showActive: this.showActive,
                });

                this.page++;

                this.list = list.content;
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
    },

    mounted() {
        this.loadItems();

        EventBus.$on("API_REGISTERED", this.reloadTable);
    },

    beforeDestroy() {
        EventBus.$off("API_REGISTERED", this.reloadTable);
    },
    mixins: [],
};
</script>

<style lang="scss" scoped>
.tab-selector {
    width: 400px;
    margin: 0 auto;
}
</style>
